module.exports = __webpack_public_path__ + "img/1.613acb27.png";